import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetContentKeywordsRes, IGetContentKeywordsQueryParams } from "types/content"
import languageSettingsService from "api/contentService"

import { LANGS } from "types/shared"

export interface IUseGetClientKeywordsParams {
  lang: LANGS,
  query: IGetContentKeywordsQueryParams,
  enabled: boolean
}

const useGetClientKeywords = ({
  lang,
  query,
  enabled
}: IUseGetClientKeywordsParams) => {
  return useQuery(["client_keywords", {...query, enabled, lang}], async () => {
    try {
      const res: AxiosResponse<IGetContentKeywordsRes> = await languageSettingsService.getClientKeywords(lang, query)

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetClientKeywords